import React, { memo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import StaticBlock from 'common/StaticBlock/StaticBlock';

import SignUpHeader from './SignUpHeader';
import useRegistrationFillingStartEvent from './useRegistrationFillingStartEvent';

const SignUpLayout = ({ children, hasBanner, onClose, signUpPopup }) => {
  const handleFieldInteraction = useRegistrationFillingStartEvent();

  return (
    <div
      className={cx({
        'no-banner': signUpPopup && !hasBanner,
        'signup-popup__container': signUpPopup,
        signup__container: !signUpPopup,
      })}
    >
      {signUpPopup && hasBanner && (
        <div className="signup-popup__with_banner">
          <StaticBlock options={{ source: 'desktop_signup_banner' }} />
        </div>
      )}
      <div
        className={cx({
          'signup-popup__col': signUpPopup,
          signup__col: !signUpPopup,
        })}
      >
        <div
          className={cx({
            'signup-popup__wrapper': signUpPopup,
            signup__wrapper: !signUpPopup,
          })}
          onChange={handleFieldInteraction}
          onClick={handleFieldInteraction}
          onInput={handleFieldInteraction}
        >
          <SignUpHeader onClose={onClose} signUpPopup={signUpPopup} />

          {children}
        </div>
      </div>

      {!signUpPopup && (
        <div className="signup__col__banner">
          <StaticBlock options={{ source: 'desktop_signup_banner' }} />
        </div>
      )}
    </div>
  );
};

SignUpLayout.propTypes = {
  children: PropTypes.node,
  hasBanner: PropTypes.bool,
  onClose: PropTypes.func,
  signUpPopup: PropTypes.bool,
  title: PropTypes.string,
};

export default memo(SignUpLayout);
